import {supportNative, getErrorFactory, logError} from './util';

// 下面针对租租车&探途地图(phoneIsExistApp) 和 探途旅行(base_phoneIsExistApp) 做兼容
import Detector from '../utils/detector';
const isZuzuche = Detector.browser.zuzuche;
const isTantuMap = Detector.browser.tantumap;
const nativeApiName = isZuzuche || isTantuMap ? 'phoneIsExistApp' : 'base_phoneIsExistApp';

const zzc = window.zzc;

/**
 * 判断系统是否已安装某APP
 *
 * @export
 * @param {any} appName APP名称，目前只支持下面几个APP：
 * * sinaWeibo
 * * wechat
 * * qq
 * * tantu
 * @returns Promise.resolve(Boolean)
 */

export default function existApp(appName) {
  return new Promise(function (resolve, reject) {
    let errorFactory = getErrorFactory(nativeApiName);

    if (!supportNative(nativeApiName)) {
      let err = errorFactory('不支持zzcjsbridge');
      logError(err);
      return reject(err);
    }

    zzc.call(nativeApiName, {
      appName: appName,
      complete: function (res) {
        if (res.state) {
          let err = errorFactory(res.message);
          logError(err);
          reject(err);
        } else {
          resolve(res.data);
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/native/existApp.js